import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CalendarStatus } from 'app/model/calendar';
import { DashboardEmployee, DashboardEmployeeCalendarStats } from 'app/model/dashboardEmployee';
import { DashboardAdminEmployeeService } from 'app/shared/services/data/dashboard/dashboard-admin-employee.service';
import { blobToBase64 } from 'app/shared/utils/imageUtils';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Component({
  selector: 'app-dashboard-admin-employee',
  templateUrl: './dashboard-admin-employee.component.html',
  styleUrls: ['./dashboard-admin-employee.component.scss']
})
export class DashboardAdminEmployeeComponent implements OnInit, OnChanges {
  private readonly ACCEPTED_CALENDAR_STATS_CLASS: string = 'success'
  private readonly PENDING_CALENDAR_STATS_CLASS: string = 'info'

  private isAccepted: boolean

  public isLoading: boolean = true

  public dashboardEmployee: DashboardEmployee

  public imgPreview: string | ArrayBuffer | null

  public calendarStats: DashboardEmployeeCalendarStats

  public calendarStatsClass: string

  @Input() public employeeId: number

  @Input() public status: CalendarStatus

  /**
   * Constructor
   *
   * @param {DashboardAdminEmployeeService} adminDashboardEmployeeService
   * 
  */
  constructor(
    private adminDashboardEmployeeService: DashboardAdminEmployeeService
  ) { }

  ngOnInit(): void {
    this.initializeValues()
  }

  ngOnChanges(changes: SimpleChanges): void {
    const status = changes['status']

    if (status && status.currentValue) this.checkIfItsAccepted(status.currentValue)

    this.getDashboardEmployee()
  }

  private initializeValues(): void {
    this.isAccepted = true

    this.calendarStatsClass = this.ACCEPTED_CALENDAR_STATS_CLASS
  }

  private getDashboardEmployee(): void {
    this.isLoading = true

    const employeeId = this.employeeId

    this.adminDashboardEmployeeService.getDashboardEmployee(employeeId)
      .pipe(
        catchError(() => this.catchError('Ha ocurrido un error al intentar cargar las estadísticas del empleado.')),
        switchMap((dashboardEmployee) => {
          this.dashboardEmployee = dashboardEmployee

          this.mapCalendarStats()

          return this.adminDashboardEmployeeService.getProfilePictureByEmployeeId(employeeId)
        }),
        switchMap((blob) => blobToBase64(blob)),
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: (data) => {
          this.imgPreview = data
        }
      })
  }

  private checkIfItsAccepted(status: CalendarStatus): void {
    const isAccepted = status === CalendarStatus.ACCEPTED

    this.isAccepted = isAccepted

    this.calendarStatsClass = isAccepted ? this.ACCEPTED_CALENDAR_STATS_CLASS : this.PENDING_CALENDAR_STATS_CLASS
  }

  private mapCalendarStats(): void {
    this.calendarStats = this.adminDashboardEmployeeService.mapCalendarStats(this.dashboardEmployee, this.isAccepted)
  }

  private catchError(htmlText: string): Observable<never> {
    const alertOptions: SweetAlertOptions = {
      title: '¡Error!',
      html: `${htmlText} <br><br> Póngase en contacto con un administrador.`,
      icon: 'error',
      customClass: {
        confirmButton: 'btn red-bg text-white ml-1'
      },
    }

    this.fireSwalAlert(alertOptions)

    return throwError(() => new Error())
  }

  private fireSwalAlert(options: SweetAlertOptions): Promise<SweetAlertResult> {
    return this.adminDashboardEmployeeService.fireSwalAlert(options)
  }
}
